// extracted by mini-css-extract-plugin
export default {"box":"BoxesFroSmall_box__4MkQa","text":"BoxesFroSmall_text__R6Aml"};